import { render, staticRenderFns } from "./hotelLinkDashboard.vue?vue&type=template&id=78d37270"
import script from "./hotelLinkDashboard.vue?vue&type=script&lang=js"
export * from "./hotelLinkDashboard.vue?vue&type=script&lang=js"
import style0 from "./hotelLinkDashboard.vue?vue&type=style&index=0&id=78d37270&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports